import styled from "styled-components";

const Container = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 400px;
  flex-direction: column;
  text-align: center;
  padding: 2rem;
  width: 100%;
`;

const Title = styled.h2`
  margin-bottom: 1rem;
  color: #666666;
  font-size: 1.5rem;
  font-weight: 600;
`;

const Message = styled.p`
  margin: 0;
  color: #666666;
  font-size: 1rem;
  line-height: 1.5;
  max-width: 400px;
`;

export default { Container, Title, Message };